import type { FeatureFlagsAppName as AppName } from "../../../models/featureFlags";
import { getGranularRuntimeEnvName } from "../../../helpers/url";
import { getCountryFromUrl } from "../../../i18n";
import {
  getOperationHeader,
  getUserHeader,
} from "../../../services/granularAxios";

import {
  getLaunchDarklyInstance,
  getContainerNameFromUrl,
} from "./featureFlags.query.helpers";

const containerName = getContainerNameFromUrl();
const granularRuntimeEnvName = getGranularRuntimeEnvName();
const country = getCountryFromUrl();

// #####################
// ## getFeatureFlags ##
// #####################

export type ParamsOfGetFeatureFlags = AppName;
export type ResultOfGetFeatureFlags = {
  isFlagEnabled: (key: string) => boolean;
};
export type GetFeatureFlags = (
  params: ParamsOfGetFeatureFlags,
) => ResultOfGetFeatureFlags;

// This is not a hook so using this is not a great idea because
// it will not react to re-fetches of feature flags, whether it be from hydration
// or from a newly selected user or operation. This function should (at the very least)
// be renamed something to indicate that it is dangerous to use.
// Personally, I think it should be removed entirely in favor of `useFeatureFlag`.
/**
 * @deprecated Use `next.hooks.useFeatureFlag` instead.
 */
export const getFeatureFlags: GetFeatureFlags = (appName) => ({
  isFlagEnabled: (key) => {
    const operationId = getOperationHeader() ?? null;
    const userId = getUserHeader() ?? null;

    const instance = getLaunchDarklyInstance({
      appName,
      containerName,
      country,
      granularRuntimeEnvName,
      operationId,
      userId,
    });

    if (instance) {
      return Boolean(instance.variation(key, false));
    }
    return false;
  },
});
